// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"mails_dashboardContainer__VWvKS","noMailSelected":"mails_noMailSelected__Bm6Ei"};